import type { Specialty } from '@quromedical/models';
import { trpcClient } from 'trpc';

export class SpecialtyApi {
  getAll = async (): Promise<Specialty[]> => {
    return await trpcClient.specialty.getAll.query();
  };
}
